<div class="table-wrapper pdb-30">
  @if (data) {
    <table>
      <thead>
        <tr>
          <td class="no-border"></td>
          <th rowspan="2" scope="col" class="header bold centered border-bold-left" translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen05</th>
          <th rowspan="2" scope="col" class="header bold centered border-bold-left" translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen025</th>
          <th scope="col" class="header bold centered border-bold-left" translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen5%</th>
          <th scope="col" class="header bold centered border-bold-left" translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen10%</th>
          <th rowspan="2" scope="col" class="header bold centered border-bold-left border-bold-right" translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.regression-output.table.colheader.sam</th>
        </tr>
        <tr>
          <td class="header border-bold-left"></td>
          <td class="header centered border-bold-left" translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen5%.subtitle</td>
          <td class="header centered border-bold-left" translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen10%.subtitle</td>
        </tr>
      </thead>
      <tbody>
        <tr appRegressionOutputTableRow [data]="data" [columns]="columns" [key]="'geschlechtskoeffizient'"></tr>
        <tr appRegressionOutputTableRow [data]="data" [columns]="columns" [key]="'standardfehler'"></tr>
        <tr appRegressionOutputTableRow [data]="data" [columns]="columns" [key]="'teststatistik'"></tr>
        <tr appRegressionOutputTableRow [data]="data" [columns]="columns" [key]="'pWert'"></tr>
        <tr appRegressionOutputTableRow [data]="data" [columns]="columns" [key]="'KIUntergrenze'"></tr>
        <tr appRegressionOutputTableRow [data]="data" [columns]="columns" [key]="'KIObergrenze'"></tr>
        <tr appRegressionOutputTableRow [data]="data" [columns]="columns" [key]="'n'" [headerItalic]="true"></tr>
        <tr appRegressionOutputTableRow [data]="data" [columns]="columns" [key]="'freiheitsgrade'"></tr>
        <tr appRegressionOutputTableRow [data]="data" [columns]="columns" [key]="'r2'"></tr>
        <tr appRegressionOutputTableRow [data]="data" [columns]="columns" [key]="'sigDiff0'"></tr>
        <tr appRegressionOutputTableRow [data]="data" [columns]="columns" [key]="'anzahlAusschluesse'"></tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="6" class="hint" translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.regression-output.footer-hint</td>
        </tr>
      </tfoot>
    </table>
  }
</div>
